<template>
  <div class="sideArea d-flex flex-column pt-5 bg-lightest position-relative">

    <div class="blueArea bg-color-1 w-100 ">
    </div>

    <div class="findTicket text-center bg-lightest p-3 border-medium radius-normal mx-3">
      <span>Insert ticket number</span>
      <input type="text" class="ticketNr w-100 border-0 text-center dark mt-0" v-model="ticketNr" @keyup.enter="viewReservation" placeholder="0000" autofocus>
      <button type="button" class="searchTicket pointer bg-color-6 radius-normal border-0 lightest font-weight-600 w-100" @click="viewReservation()">Find a ticket</button>
    </div>

    <div class="newBooking p-3 my-2 w-100">
      <button type="button" class="newBookingBtn pointer bg-dark radius-normal border-0 lightest w-100 fs-large" @click="newReservation">New Booking</button>
    </div>

    <div class="informationArea p-3 w-100 bg-lighter border-top-light border-bottom-light scroll-y-auto">

        <div class="text-center dark bold fs-large w-50 m-auto mt-5 pt-5" v-if="nrVisibleAlerts < 1">
          You have no notes or alerts.
        </div>

        <div class="infoCard fs-small pb-2 mt-2" v-for="notification in notifications" v-if="!notification.markedAsRead">
            <notification class="border-bottom-medium" :notification="notification"></notification>
        </div>

    </div>

    <router-link :to="{ name: 'notifications' }">
        <!-- <div class="bold text-center font-weight-600 py-2 moreAlerts brand" v-if="nrVisibleAlerts > 0"> -->
        <div class="bold text-center font-weight-600 py-2 moreAlerts brand" v-if="false">
          {{nrVisibleAlerts}} more alerts
        </div>

        <div class="dark text-center py-2" v-else>
          view all
        </div>
    </router-link>

  </div>
</template>

<script>
    import Notification from '@/components/common/notifications/default'
    import { mapGetters, mapActions } from 'vuex'

    export default {
        created: function(){
        },
        data: function(){
            return{
                ticketNr: null,
            }
        },
        computed:{
            ...mapGetters([
                'getNotifications',
                'getUnreadNotificationsNr',
                'account'
            ]),
            notifications: function() {
                return this.getNotifications.result;
            },
            nrVisibleAlerts: function(){
                return this.getUnreadNotificationsNr;
            }
        },
        methods: {
            ...mapActions([
                'openModal',
                'setSelectedReservation',
                'markNotificationAsRead',
                'openReservationById'
            ]),
            newReservation() {
                this.$router.push('/reservation')
            },
            viewReservation: function() {
                if(this.ticketNr){
                    this.openReservationById(this.ticketNr)
                }
            },
            triggerModal: function(id, modal) {
                console.log('triggering modal', id, modal);
                this.setSelectedReservation(id);
                this.openModal(modal);
            },
            dismissAlert: function(notification){
                this.markNotificationAsRead(notification);
            },
        },
        components: {
            Notification
        }
    }
</script>

<style scoped lang="scss">
  @import '../../assets/scss/_variables.scss';
  @import '../../assets/scss/_mixins.scss';

  .scroll-y-auto{
      overflow-y: auto;
  }

  .sideArea{

    box-shadow: 0 1px 4px 0 $dark;
    height: 100%;

    .blueArea{
      height: 138px;
      position: absolute;
      z-index: 0;
      top: 0;
    }

    .findTicket{
      position: relative;
      z-index: 1;

      input.ticketNr{
        @include placeholder-color($gray);
        font-size: 36px;      // .font-size-larger
      }

      button.searchTicket{
        height: 45px;
      }

    }

    .newBooking .newBookingBtn{
      height: 60px;
    }

    .informationArea{
      height: 10px; // fix - makes height 100%
      position: relative;
      flex-grow: 1;

      .infoCard{
        width: 100%;
        .date{
          font-size: 12px;
          font-style: italic;
          line-height: 1.58;
        }
        .infoContent{
          line-height: 1.36;
        }
      }

    }


  }
</style>



// WEBPACK FOOTER //
// SidePanel.vue?f9eda358